export default __webpack_public_path__ + "static/media/plus.9d5643e5.svg";